import { RetryLink } from "@apollo/client/link/retry";

const doNotRetryCodes = [403, 400];

const doNotRetryOperations = [
  "SendEmailOtp",
  "InvalidateRefreshToken",
  "verifyAuthCode",
];

const retryLink = new RetryLink({
  delay: {
    initial: 100,
    max: 500,
    jitter: true,
  },
  attempts: {
    max: 3,
    retryIf: (_error, operation) =>
      !doNotRetryOperations.includes(operation.operationName) &&
      !doNotRetryCodes.includes(_error.statusCode),
  },
});

export { retryLink };
